import styled from '@emotion/styled';
import { Space } from 'antd';
import { useFlagConfigValue } from 'hooks/business/system/useFlagConfig';
import { useTranslate } from '@tolgee/react';

const Item = styled.div`
  & > img {
    width: 120px;
    height: 120px;
  }

  & > p {
    text-align: center;
  }
`;

function MobileApp() {
  const { t } = useTranslate();
  const { androidQrcode, iosQrcode } = useFlagConfigValue();

  return (
    <Space size={24}>
      <Item>
        <img src={androidQrcode} alt="android" />
        <p>{t('header.android')}</p>
      </Item>
      <Item>
        <img src={iosQrcode} alt="ios" />
        <p>{t('header.ios')}</p>
      </Item>
    </Space>
  );
}

export default MobileApp;
